const smoother = ScrollSmoother.create({
	smooth: 5,
	smoothTouch: 5,
	speed: 0.5,
	effects: true,
})

window.addEventListener('load', () => {
	gsap.set(smoother, {
		duration: 0,
		scrollTop: 0,
	})
})

const tl = gsap.timeline({
	defaults: { ease: 'power4.easeOut' },
	scrollTrigger: {
		trigger: '.anime-wrapper',
		pin: '.anime-container',
		scrub: true,
		start: 'top top',
		end: 'bottom top',
	},
})

// Logo
const rect = document.querySelector('.get-position')
const logo = document.querySelector('.main__logo')

let bodyRect = document.body.getBoundingClientRect(),
	elemRect = rect.getBoundingClientRect(),
	offsetTop = elemRect.top - bodyRect.top,
	offsetLeft = elemRect.left - bodyRect.left

let mm = gsap.matchMedia()

mm.add('(min-width: 961px)', () => {
	tl.to(
		logo,
		{
			width: '220rem',
			transform: 'none',
			left: offsetLeft + 15,
			top: offsetTop,
		},
		0
	)
		.to(
			'.header__menu-offset',
			{
				'margin-top': '75rem',
			},
			'<'
		)
		.to(
			'.main__box',
			{
				top: '505rem',
			},
			'<'
		)
		.to(
			'.main__container',
			{
				bottom: '125rem',
			},
			'<'
		)
		.to(
			'.main__box-logo',
			{
				rotate: '90deg',
				width: '700rem',
			},
			'>'
		)
		.to(
			'.anime-wrapper__inner',
			{
				translateY: '-1200rem',
			},
			'<'
		)
		.to(
			'.main__box',
			{
				top: '1630rem',
				left: '860rem',
			},
			'<'
		)
		.to(
			'.main__product',
			{
				opacity: '1',
				duration: 0,
			},
			'>'
		)
		.to(
			'.main__product',
			{
				right: '200rem',
				width: '240rem',
				bottom: '50%',
			},
			'>'
		)
		.to(
			'.anime-wrapper__inner',
			{
				translateY: '-2900rem',
			},
			'>'
		)
		.to(
			'.main__product',
			{
				right: '300rem',
				width: '320rem',
				bottom: '-1580rem',
			},
			'<'
		)
})

mm.add('(max-width: 960px)', () => {
	tl.to(
		logo,
		{
			width: '138rem',
			transform: 'none',
			left: offsetLeft + 15,
			top: offsetTop,
		},
		0
	)
		.to(
			'.main__box',
			{
				top: '290rem',
			},
			'<'
		)
		.to(
			'.main__container',
			{
				bottom: '50rem',
			},
			'<'
		)
		.to(
			'.main__box-logo',
			{
				rotate: '90deg',
				width: '345rem',
			},
			'>'
		)
		.to(
			'.anime-wrapper__inner',
			{
				translateY: '-700rem',
			},
			'<'
		)
		.to(
			'.main__box',
			{
				top: '1000rem',
				left: '100rem',
			},
			'<'
		)
		.to(
			'.main__product',
			{
				opacity: '1',
				duration: 0,
			},
			'>'
		)
		.to(
			'.main__product',
			{
				right: '10rem',
				width: '110rem',
				bottom: '50%',
			},
			'>'
		)
		.to(
			'.anime-wrapper__inner',
			{
				translateY: '-1700rem',
			},
			'>'
		)
		.to(
			'.main__product',
			{
				bottom: '-930rem',
			},
			'<'
		)
})
//
